import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell, AuthError, authInputClass, authButtonClass } from "@/components/auth/AuthShell";

function ResetLinkNotice({ result }) {
  return (
    <div className="space-y-4" data-testid="forgot-result">
      <div className="text-sm text-slate-300 border-l-2 border-amber pl-3 py-2 bg-amber/5">{result.message}</div>
      {result.reset_path && (
        <div className="border border-surface-3 bg-surface p-4" data-testid="reset-link-box">
          <div className="text-[10px] font-condensed uppercase tracking-[0.3em] text-amber mb-2">
            Email delivery not connected yet — use this link (valid 1 hour, one use)
          </div>
          <Link to={result.reset_path} data-testid="reset-link"
            className="text-sm text-white hover:text-amber underline break-all">
            {window.location.origin}{result.reset_path}
          </Link>
        </div>
      )}
    </div>
  );
}

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setResult(data);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <AuthShell eyebrow="Account recovery" title="Reset Password"
      subtitle="Enter your staff email and we'll create a secure reset link.">
      {result ? <ResetLinkNotice result={result} /> : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <div>
            <Label className="text-[10px] font-condensed tracking-[0.3em] uppercase text-slate-400">Email</Label>
            <Input data-testid="forgot-email" type="email" value={email} required autoFocus
              onChange={(e) => setEmail(e.target.value)} className={authInputClass} />
          </div>
          <AuthError testid="forgot-error">{error}</AuthError>
          <Button type="submit" disabled={busy} data-testid="forgot-submit" className={authButtonClass}>
            {busy ? "Creating link…" : "Send Reset Link"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
